var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstallerTierPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14485_80079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0884 2.95773V24.0109C27.0884 26.704 25.8795 29.2169 23.777 30.9086C22.2968 32.0982 20.7672 33.2688 19.2321 34.3875C16.6115 36.2974 15.2299 37.1487 13.9717 37.1487C12.7135 37.1487 11.3292 36.2974 8.71132 34.3875C7.1735 33.2688 5.6439 32.0982 4.16365 30.9086C2.06114 29.2169 0.855002 26.704 0.855002 24.0109V3.05596C0.852261 2.61667 0.852261 2.01366 1.08526 1.75446C1.32101 1.49252 1.92682 1.43522 2.36815 1.39429H2.41201C6.23874 1.0314 10.1258 0.851318 13.9717 0.851318C17.8176 0.851318 21.7047 1.0314 25.5314 1.39156H25.5725C26.0166 1.43522 26.6197 1.49252 26.8554 1.75446C27.072 1.99457 27.0884 2.53208 27.0884 2.95773Z",
    fill: "url(#paint0_radial_14485_80079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0884 2.95773C27.0363 2.97683 26.9815 3.00139 26.9184 3.03413C26.7019 3.14327 22.5819 6.25377 17.6888 9.97001H17.686C17.0199 10.4748 16.3429 10.9905 15.6575 11.5143C13.3111 13.2961 10.8906 15.1433 8.70858 16.8077C7.74367 17.5444 6.8281 18.2429 5.98655 18.8868C3.11924 21.0805 1.11268 22.6248 1.03866 22.7012C0.967392 22.7749 0.904344 22.8704 0.855002 22.9714V3.05596C0.852261 2.61667 0.852261 2.01366 1.08526 1.75446C1.32101 1.49252 1.92682 1.43522 2.36815 1.39429H2.41201C6.23874 1.0314 10.1258 0.851318 13.9717 0.851318C17.8176 0.851318 21.7047 1.0314 25.5314 1.39156H25.5725C26.0166 1.43522 26.6197 1.49252 26.8554 1.75446C27.072 1.99457 27.0884 2.53208 27.0884 2.95773Z",
    fill: "url(#paint1_radial_14485_80079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9328 10.0928C20.8439 11.6071 22.6696 14.603 22.6778 17.8718C22.6778 18.4639 22.2008 18.9468 21.606 18.9496H6.34292C5.74808 18.9496 5.26562 18.4721 5.26562 17.8773C5.26562 17.2852 5.74808 16.8049 6.34292 16.8049H20.4218C19.8078 13.1788 16.3538 10.734 12.708 11.3452C10.6521 11.689 8.8758 12.9659 7.90267 14.7995C7.62581 15.3261 6.9734 15.528 6.44709 15.2524C5.91803 14.9796 5.71518 14.3302 5.99205 13.8036C8.25903 9.49799 13.6071 7.8336 17.9383 10.0901L17.9328 10.0928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8531 20.7667C7.87777 20.8104 7.90244 20.8595 7.91889 20.9059C9.50057 24.2292 13.4918 25.648 16.8333 24.0764C18.2341 23.4188 19.3607 22.2974 20.0213 20.9059C20.3147 20.3902 20.9725 20.2101 21.4906 20.5021C21.9566 20.764 22.1567 21.3261 21.9621 21.8227C20.5586 24.7776 17.6228 26.7149 14.3416 26.8486L13.9715 26.854C10.5532 26.854 7.43918 24.8977 5.97537 21.8227C5.68206 21.3097 5.86298 20.6549 6.38107 20.3629C6.89916 20.071 7.55705 20.251 7.85036 20.7667H7.8531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9385 2.86494C27.9385 2.30559 27.8974 1.63711 27.4917 1.1869C27.023 0.665757 26.2061 0.600273 25.6113 0.542974C21.7407 0.180082 17.8564 0 13.9721 0C10.0878 0 6.20347 0.180082 2.33014 0.542974C1.7353 0.600273 0.918416 0.665757 0.449669 1.1869C-0.0190786 1.70532 0.000109889 2.52387 0.000109889 3.11869V24.0109C0.000109889 26.9468 1.33234 29.7244 3.62673 31.5689C5.12618 32.7749 6.65029 33.9427 8.20456 35.075C10.8827 37.0232 12.426 38 13.9721 38C15.5181 38 17.0614 37.0232 19.7368 35.075C21.2911 33.9427 22.8152 32.7749 24.3147 31.5689C26.6091 29.7244 27.9413 26.9468 27.9413 24.0109V3.11869C27.9413 3.03683 27.9413 2.95225 27.9385 2.86494ZM27.0888 24.0109C27.0888 26.704 25.8799 29.2169 23.7774 30.9086C22.2971 32.0982 20.7675 33.2688 19.2325 34.3874C16.6119 36.2974 15.2303 37.1487 13.9721 37.1487C12.7139 37.1487 11.3295 36.2974 8.71168 34.3874C7.17386 33.2688 5.64427 32.0982 4.16401 30.9086C2.0615 29.2169 0.855368 26.704 0.855368 24.0109V3.05593C0.852627 2.61664 0.852627 2.01364 1.08563 1.75443C1.32137 1.4925 1.92718 1.4352 2.36852 1.39427H2.41238C6.23911 1.03138 10.1261 0.851296 13.9721 0.851296C17.818 0.851296 21.705 1.03138 25.5318 1.39154H25.5729C26.017 1.4352 26.62 1.4925 26.8558 1.75443C27.0723 1.99454 27.0888 2.53206 27.0888 2.95771V24.0109Z",
    fill: "url(#paint2_linear_14485_80079)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14485_80079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.33414 4.91953) scale(36.5075 36.3383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#757C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#302F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14485_80079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8249 11.4146) rotate(6.25114) scale(31.048 25.0351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#858C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#777D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#606466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#302F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14485_80079",
    x1: 0.353726,
    y1: 1.27967,
    x2: 27.4612,
    y2: 28.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5F605F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14485_80079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9412,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallerTierPlatinum);
export default __webpack_public_path__ + "static/media/icon_installer_tier_platinum.4cf5f0c8e18ea9218ada50a5cc5f9bc8.svg";
export { ForwardRef as ReactComponent };